<template>

  <!-- Table Container Card -->
  <b-card
    no-body
  >

    <div class="m-2">

      <!-- Table Top -->
      <b-row>

        <!-- Per Page -->
        <b-col
          cols="12"
          md="6"
          class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
        >
          <label>Entries</label>
          <v-select
            v-model="perPage"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="perPageOptions"
            :clearable="false"
            class="per-page-selector d-inline-block ml-50 mr-1"
          />
          <!-- <b-button
            variant="primary"
            :to="{ name: 'apps-invoice-add'}"
          >
            Add Record
          </b-button> -->
        </b-col>

        <!-- Search -->
        <b-col
          cols="12"
          md="6"
        >
          <div class="d-flex align-items-center justify-content-end">
            <!-- <b-form-input
              v-model="searchQuery"
              class="d-inline-block mr-1"
              placeholder="Search..."
            /> -->
            <v-select
              v-model="statusFilter"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="statusOptions"
              class="invoice-filter-select"
              placeholder="Selecione o Filtro"
            >
              <template #selected-option="{ label }">
                <span class="text-truncate overflow-hidden">
                  {{ label }}
                </span>
              </template>
            </v-select>
          </div>
        </b-col>
      </b-row>

    </div>

    <b-table
      ref="refInvoiceListTable"
      :items="fetchInvoices"
      responsive
      :fields="tableColumns"
      primary-key="id"
      :sort-by.sync="sortBy"
      show-empty
      empty-text="No matching records found"
      :sort-desc.sync="isSortDirDesc"
      class="position-relative"
    >

      <!-- Column: firstPlatformId -->
      <template #cell(firstPlatformId)="data">
        <template v-if="data.item.first_transaction.platform_id">
          <a
            v-b-modal.modal-first-transaction
            variant="outline-primary"
            @click="getFirstTransaction(data.item.first_transaction.platform_id, data.item.first_transaction.product, data.item.first_transaction.subcustomer)"
          >{{ data.item.first_transaction.platform_id }}</a>
        </template>
        <template v-else>
          <a
            v-b-modal.modal-first-transaction
            variant="outline-primary"
            class="center"
            align-items-center
            @click="getFirstTransaction(data.item.first_transaction.platform_id, data.item.first_transaction.product, data.item.first_transaction.subcustomer)"
          > 🛒 </a>
        </template>
      </template>

      <!-- Column: statusOrigin -->
      <template #cell(statusOrigin)="data">
        <template v-if="data.item.first_transaction.status_id">
          {{ status[data.item.first_transaction.status_id] }}<br>
          <span>{{ payment[data.item.first_transaction.payment_id] }}</span><br>
        </template>
        <template v-else>
          -
        </template>
      </template>

      <!-- Column: lastPlatformId -->
      <template #cell(lastPlatformId)="data">
        <template v-if="data.item.last_transaction_id">
          <a
            v-b-modal.modal-primary
            variant="outline-primary"
            @click="getLastTransaction(data.item.last_transaction.platform_id, data.item.last_transaction.product, data.item.last_transaction.subcustomer)"
          >{{ data.item.last_transaction.platform_id }}</a>
        </template>
        <template v-else>
          -
        </template>
      </template>

      <!-- Column: Balance -->
      <template #cell(total)="data">
        <template v-if="data.item.last_transaction_id">
          <span>{{ data.item.last_transaction.amount }}</span>
        </template>
        <template v-else>
          -
        </template>
      </template>

      <!-- Column: Balance -->
      <template #cell(paymentStatus)="data">
        <template v-if="data.item.last_transaction_id">
          <b-badge
            pill
            variant="light-success"
          >
            Pago
          </b-badge><br>
          <span>{{ payment[data.item.last_transaction.payment_id] }}</span><br>
        </template>
        <template v-else>
          <b-badge
            pill
            variant="light-danger"
          >
            Não Pago
          </b-badge>
        </template>
      </template>

      <!-- Column: Client -->
      <template #cell(client)="data">
        <b-media vertical-align="center">
          <span class="font-weight-bold d-block text-nowrap">
            {{ data.item.first_transaction.subcustomer.name }}
          </span>
          <small class="text-muted">{{ data.item.first_transaction.subcustomer.checkout_email }}</small><br>
          <small class="text-muted"> <a
            :href="'http://wa.me/55' + data.item.first_transaction.subcustomer.checkout_phone"
            target="_blank"
          >{{ data.item.first_transaction.subcustomer.checkout_phone }} </a></small>
        </b-media>
      </template>

      <!-- Column: Issued Date -->
      <template #cell(ContactDate)="data">
        <span class="text-nowrap">
          {{ data.item.last_contact_at }}
        </span>
      </template>

      <!-- Column: Actions -->
      <template #cell(actions)="data">

        <div class="text-nowrap">
          <feather-icon
            :id="`invoice-row-${data.item.id}-send-icon`"
            icon="SendIcon"
            class="cursor-pointer"
            size="16"
          />
          <b-tooltip
            title="Send Invoice"
            class="cursor-pointer"
            :target="`invoice-row-${data.item.id}-send-icon`"
          />

          <feather-icon
            :id="`invoice-row-${data.item.id}-preview-icon`"
            icon="EyeIcon"
            size="16"
            class="mx-1"
            @click="$router.push({ name: 'apps-invoice-preview', params: { id: data.item.id }})"
          />
          <b-tooltip
            title="Preview Invoice"
            :target="`invoice-row-${data.item.id}-preview-icon`"
          />

          <!-- Dropdown -->
          <b-dropdown
            variant="link"
            toggle-class="p-0"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >

            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>
            <b-dropdown-item>
              <feather-icon icon="DownloadIcon" />
              <span class="align-middle ml-50">Download</span>
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: 'apps-invoice-edit', params: { id: data.item.id } }">
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Edit</span>
            </b-dropdown-item>
            <b-dropdown-item>
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">Delete</span>
            </b-dropdown-item>
            <b-dropdown-item>
              <feather-icon icon="CopyIcon" />
              <span class="align-middle ml-50">Duplicate</span>
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </template>

    </b-table>
    <div class="mx-2 mb-2">
      <b-row>

        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-start"
        >
          <span class="text-muted">Showing {{ dataMeta.from }} to {{ dataMeta.to }} of {{ dataMeta.of }} entries</span>
        </b-col>
        <!-- Pagination -->
        <b-col
          cols="12"
          sm="6"
          class="d-flex align-items-center justify-content-center justify-content-sm-end"
        >

          <b-pagination
            v-model="currentPage"
            :total-rows="totalInvoices"
            :per-page="perPage"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            prev-class="prev-item"
            next-class="next-item"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>

        </b-col>

      </b-row>
    </div>
    <!-- Last Transaction -->
    <b-modal
      id="modal-primary"
      ok-only
      ok-title="Accept"
      modal-class="modal-primary"
      centered
      title="Primary Modal"
    >
      <b-card-text>
        <span>Número do Pedido: {{ last_platform_id }}</span>
        <br><span>Produtos:</span>
        <template>
          <b-list-group>
            <b-list-group-item
              v-for="item in last_items"
              :key="item"
            >
              {{ item.name }}
            </b-list-group-item>
          </b-list-group>
        </template>
      </b-card-text>
    </b-modal>

    <!--- First Transaction --->
    <b-modal
      id="modal-first-transaction"
      ok-only
      ok-title="Accept"
      modal-class="modal-primary"
      centered
      title="modal-first-transaction"
    >
      <b-card-text>
        <span>Número do Pedido: {{ first_platform_id }}</span>
        <br><span>Produtos:</span>
        <template>
          <b-list-group>
            <b-list-group-item
              v-for="item in first_items"
              :key="item"
            >
              {{ item.name }}
            </b-list-group-item>
          </b-list-group>
        </template>
      </b-card-text>
    </b-modal>
  </b-card>

</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BButton, BTable, BMedia, BAvatar, BLink,
  BBadge, BDropdown, BDropdownItem, BPagination, BTooltip, BModal, VBModal,
  BListGroup, BListGroupItem,
} from 'bootstrap-vue'
import { avatarText } from '@core/utils/filter'
import vSelect from 'vue-select'
import { onUnmounted } from '@vue/composition-api'
import store from '@/store'
import { toRefs } from 'vue'
import useInvoicesList from './useInvoiceList'

import invoiceStoreModule from '../invoiceStoreModule'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    BModal,
    VBModal,
    vSelect,
    BListGroup,
    BListGroupItem,
  },
  directives: {
    'b-modal': VBModal,
  },
  props: {
    attendigs: Array,
  },
  data() {
    return {
      status: {
        1: 'Aguardando Pagamento', 2: 'Pedido Recusado', 3: 'Aguardando Pagamento', 4: 'Reembolsada', 5: 'Em Disputa', 6: 'Completa', 7: 'Bloqueada', 8: 'Estorno', 9: 'Atrasada', 10: 'Expirada', 11: 'Finalizada', 12: 'Carrinho Abandonado', 13: 'Pagamento em Análise', 14: 'Nota Fiscal', 15: 'Transporte',
      },
      payment: {
        1: '-', 2: '║▌║█║▌│║▌║▌█', 3: '💳', 4: '💳', 5: 'Paypal', 6: '❖ Pix', 7: '🏦', 8: 'Moip', 9: 'Bcash', 10: 'Hotmart', 11: 'Mercado Pago', 12: 'Boleto + 💳', 13: 'Addi', 14: 'Pagaleve', 15: 'Ame', 16: '❖', 17: 'Koin', 18: '💳💳', 23: 'Nupay', 24: 'Marketplace',
      },
      last_platform_id: null,
      last_items: [],
      last_customer: {},
      first_platform_id: null,
      first_items: [],
      first_customer: {},
    }
  },
  methods: {
    getLastTransaction(platformId, products, customerInfos) {
      this.last_platform_id = platformId
      this.last_items = products
      this.last_customer = customerInfos
    },
    getFirstTransaction(platformId, products, customerInfos) {
      this.first_platform_id = platformId
      this.first_items = products
      this.first_customer = customerInfos
    },
  },
  setup(props) {
    const INVOICE_APP_STORE_MODULE_NAME = 'app-invoice'

    // Register module
    if (!store.hasModule(INVOICE_APP_STORE_MODULE_NAME)) store.registerModule(INVOICE_APP_STORE_MODULE_NAME, invoiceStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(INVOICE_APP_STORE_MODULE_NAME)) store.unregisterModule(INVOICE_APP_STORE_MODULE_NAME)
    })

    const statusOptions = [
      'Pago',
      'Não Pago',
    ]

    const {
      fetchInvoices,
      tableColumns,
      perPage,
      currentPage,
      totalInvoices,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refInvoiceListTable,

      statusFilter,

      refetchData,

      resolveInvoiceStatusVariantAndIcon,
      resolveClientAvatarVariant,
    } = useInvoicesList(props.attendigs)

    return {
      fetchInvoices,
      tableColumns,
      perPage,
      currentPage,
      totalInvoices,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refInvoiceListTable,

      statusFilter,

      refetchData,

      statusOptions,

      avatarText,
      resolveInvoiceStatusVariantAndIcon,
      resolveClientAvatarVariant,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.invoice-filter-select {
  min-width: 190px;

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 100px;
  }
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
